// extracted by mini-css-extract-plugin
export default {"wrap":"VseyUHg2rWsC7kDPjUqA","dropdown":"gHg2YxqBWYkViI6yL3LR","size-0":"Df967b71xPbWu8aCToq9","size-1":"anTP9l1hvSs3faddolL4"};